import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { FAQS } from '../data/content';
import Reveal from './Reveal';

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section className="section-pad" data-testid="home-faq">
      <div className="content-container">
        <div className="grid grid-cols-12 gap-y-10 md:gap-10 lg:gap-16">
          <div className="col-span-12 lg:col-span-4">
            <Reveal><div className="eyebrow mb-5">Frequently Asked</div></Reveal>
            <Reveal delay={120}>
              <h2 className="display text-white/95 text-2xl md:text-3xl lg:text-4xl tracking-[-0.015em] leading-[1.12]">
                The answers, before <span className="text-[#C9A56C]">you ask.</span>
              </h2>
            </Reveal>
            <Reveal delay={200}>
              <p className="text-white/55 text-[14px] md:text-[15px] leading-[1.8] mt-6 max-w-md">
                Still have a question? Write to <a href="mailto:awards@marketingmind.co" className="text-[#C9A56C] hover:underline">awards@marketingmind.co</a> and we&rsquo;ll respond within 48 hours.
              </p>
            </Reveal>
          </div>
          <div className="col-span-12 lg:col-span-8">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <Reveal key={f.q} delay={i * 70} className="border-t border-[#C9A56C]/20">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`faq-toggle-${i}`}
                    aria-expanded={isOpen}
                    className="w-full text-left flex items-start justify-between gap-6 py-6 md:py-7 group"
                  >
                    <span className="flex items-baseline gap-5 md:gap-6 min-w-0">
                      <span className="numeral text-base md:text-lg flex-shrink-0">{String(i + 1).padStart(2, '0')}</span>
                      <span className={`font-serif text-lg md:text-xl leading-snug transition-colors ${isOpen ? 'text-[#C9A56C]' : 'text-white/90 group-hover:text-[#C9A56C]'}`}>
                        {f.q}
                      </span>
                    </span>
                    <Plus
                      size={18}
                      className={`text-[#C9A56C] flex-shrink-0 mt-1 transition-transform duration-500 ${isOpen ? 'rotate-45' : ''}`}
                    />
                  </button>
                  <div className={`grid transition-all duration-500 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                    <div className="overflow-hidden">
                      <p className="pl-12 md:pl-14 pr-2 pb-7 text-white/65 font-sans text-[15px] leading-[1.85] max-w-2xl">
                        {f.a}
                      </p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
            <div className="border-t border-[#C9A56C]/20" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
